import { useQueryClient } from "@tanstack/react-query";
import { useMesfRealtime } from "@dexteel/mesf-core";

/**
 * Maps stored procedure names (broadcast via SignalR) to TanStack Query key
 * prefixes. When the backend executes a source SP that targets one of these
 * (configured in SYSTEM.QueryCacheInvalidations), the cache is invalidated
 * automatically for every connected client.
 */
const SP_TO_QUERY_KEYS: Record<string, readonly string[][]> = {
  "RBD.GetPartTypesMetricLimits": [["metric-limits"]],
};

/**
 * Listens to SignalR messages and invalidates Metric Limits query cache.
 * Call once at the MetricLimitsPage level.
 */
export const useRealtimeInvalidation = () => {
  const queryClient = useQueryClient();

  useMesfRealtime({
    onReceiveMessage: (_author: string, message: string) => {
      const queryKeys = SP_TO_QUERY_KEYS[message];
      if (queryKeys) {
        queryKeys.forEach((queryKey) => {
          queryClient.invalidateQueries({ queryKey });
        });
      }
    },
  });
};
